import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useBreadcrumbsFeature } from "../../composables";


export default /*@__PURE__*/_defineComponent({
  __name: 'BreadcrumbsBlock',
  setup(__props) {

const { breadcrumbValues } = useBreadcrumbsFeature();

return (_ctx: any,_cache: any) => {
  const _component_d_breadcrumbs = _resolveComponent("d-breadcrumbs")!

  return (_openBlock(), _createBlock(_component_d_breadcrumbs, { items: _unref(breadcrumbValues) }, null, 8, ["items"]))
}
}

})